import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IFeedbackApi } from "@/api/feedback";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { Feedback } from "@/models/feedback";
import { useToast } from "@/hooks/use-toast";

export const useDeleteFeedback = () => {
  const feedbackApi = useInjection<IFeedbackApi>(SERVICES_TYPES.FEEDBACK);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) => feedbackApi.remove(id),
    onSuccess: (_data, id) => {
      // Drop the deleted item from the cache directly to avoid a refetch lag.
      queryClient.setQueryData<Feedback[]>(["feedback"], (current) =>
        current?.filter((item) => item._id !== id)
      );
      toast({ title: "Feedback deleted" });
    },
    onError: (error) => {
      toast({
        title: "Failed to delete feedback",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
